module.exports = __webpack_public_path__ + "img/img-share1.9d69580d.png";